import React from 'react'

const CardCategory = ({img, title , price, about}) => {
  return (
    <>
     <div className="d-flex justify-content-center justify-content-lg-between align-items-center gap-md-5 gap-2 flex-lg-nowrap flex-wrap">
        

          
              <div
                className=" border inspection_cardPkg mb-4 position-relative p-3 shadow-sm"
               
                style={{ borderRadius: "10px", maxWidth: "400px" }}
              >
                <img
                  src={img}
                  alt="car-inspection"
                  style={{ width: "100%", borderRadius: "8px" }}
                />

                <h4 className="mt-3 text-center">{title}</h4>
                <p className="color-secondary fw-semibold text-center">
                  {about}
                </p>

                <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
                 

                  <p
                    className="color-secondary fw-bold fs-5 m-0"
                    style={{ fontSize: "1.2rem" }}
                  >
                  {price}  
                  </p>
                </div>
              </div>
          
        </div>
    
    </>
  )
}

export default CardCategory
